<script>

export default {
  methods: {
    fSnackBarSuccess(text, showSnackbar='BOTH'){
      if(showSnackbar === 'SON' || showSnackbar === 'BOTH'){
        let snackbar = {
          text: text,
          type: 'success',
          time: 5000
        }

        this.$bus.$emit('showSnackbar', snackbar)
      }

      if(showSnackbar === 'PARENT' || showSnackbar === 'BOTH'){
        this.$emit('snackbar-msg', {type: 'success', text: text} )
      }

    },

    fSnackbarError(textError, showSnackbar){
      let errorSrv = null
      if(textError.errorMsg && textError.errorMsg.message){
        errorSrv = textError.errorMsg.message
      }
      
      if(showSnackbar === 'SON' || showSnackbar === 'BOTH'){
        const snackbar = {
          text: errorSrv != null ? errorSrv : textError,
          type: 'error',
          time: 15000
        }

        this.$bus.$emit('showSnackbar', snackbar)
      }
      if(showSnackbar === 'PARENT' || showSnackbar === 'BOTH'){
          this.$emit('snackbar-msg', {type: 'error', error: textError} )
        }
    },

    fThrowError(mensageError, showSnackbar){
      if(mensageError != null){
        this.fSnackbarError(mensageError, showSnackbar)
        throw Error(mensageError)
      }
    },

    fSnackBarError2(error, showSnackbar='BOTH'){
      if(error != null){
        if(showSnackbar === 'SON' || showSnackbar === 'BOTH'){
          let snackbar = {
            text: error.errorMsg != null ? error.errorMsg : error,
            type: 'error',
            time: 15000
          }

          this.$bus.$emit('showSnackbar', snackbar)
        }

        if(showSnackbar === 'PARENT' || showSnackbar === 'BOTH'){
          this.$emit('snackbar-msg', {type: 'error', error: error} )
        }
      }
    }
  },
}
</script>
